import { PaymentRequest, PaymentResponse, Transaction } from '@app/model/payments/payments.model';
import { Action, createAction, props } from '@ngrx/store';

export const clearGuestPaymentRequest = createAction(
    '[PAYMENTS] LOAD_GUEST_PAYMENT'
);

export const loadGuestPayment = createAction(
    '[PAYMENTS] LOAD_GUEST_PAYMENT',
    props<{ guestPaymentRequest: PaymentRequest }>()
);

export const clearGuestPayment = createAction(
    '[PAYMENTS] CLEAR_GUEST_PAYMENT'
);

export const loadGuestPaymentSuccess = createAction(
    '[PAYMENTS] LOAD_GUEST_PAYMENT_SUCCESS',
    props<{ guestPayment: PaymentResponse }>()
);

export const loadGuestPaymentFailed = createAction(
    '[PAYMENTS] LOAD_GUEST_PAYMENT_FAILED',
    props<{ guestPaymentError: string }>()
);

export const loadTransaction = createAction(
    '[PAYMENTS] LOAD_TRANSACTION',
    props<{ sessionId: string; verification: string }>()
);

export const loadTransactionSuccess = createAction(
    '[PAYMENTS] LOAD_TRANSACTION_SUCCESS',
    props<{ transaction: Transaction }>()
);
